export const AppointmentType = {
    task: "96f359ba-fc9a-4a16-9d93-391348d8d53d",
  };
